import qs from 'qs'
import { post,ajaxParam } from '@/units/request.js'
export default {
	data(){
		return {
			detailmodel: {},
			userId: '',
			id: ''
		}
	},
	created(){
		this.userId = localStorage.getItem('userId')
		this.id = this.$route.query.id
		this.getDetailModel()
	},
	methods: {
		//获取大赛详情数据
		async getDetailModel(){
			let param = {
				id: this.id,
				userId: this.userId
			}
			ajaxParam(param)
			const res = await post('v1/competition/competitionInfo', qs.stringify(param))
			if(res.data.code==200){
				console.log('详情详情详情详情详情详情')
				console.log(res.data)
				this.detailmodel = res.data.entity
			} else {
				this.$message.error(res.data.msg)
			}
		}
	}
}
